import React from "react";
import "./Events.scss";
import eventOne from "../../../assets/event1.png";
import eventTwo from "../../../assets/event2.jpg";
import eventThree from "../../../assets/event3.jpg";
import useEventsData from "../../../hooks/useEventsData";
import HomeEventCard from "./HomeEventCard/HomeEventCard";

const Events = () => {
  const [eventData, setEventData] = useEventsData();

  return (
    <>
      <div className="events">
        <div className="heading_box">
          <h2>Latest Event and Photos</h2>
        </div>{" "}
        <div className="container">
          <div className="events_content">
            {/* <div className="row">
              {eventData.slice(0, 3).map((events) => (
                <HomeEventCard events={events} key={events.id}></HomeEventCard>
              ))}
              <div className="col-lg-4">
                <div className="event_box">
                  <img src={eventOne} alt="" className="img-fluid" />
                  <div className="">
                    <div className="date_text">10 April 2020By Admin</div>
                    <p>2020 Insurance Trends And Possible Challenge</p>
                    <div className="text-end">
                      <button className="btn read_more_btn">
                        Read More...
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </div> */}

            <div className="row" data-aos="zoom-in-up">
              <div className="col-lg-4 mb-lg-0 mb-3">
                <div className="event_box">
                  <img src={eventTwo} alt="" className="img-fluid event_img" />
                  <div className="event_text_content">
                    <div className="date_text">10 April 2020By Admin</div>
                    <p>2020 Insurance Trends And Possible Challenge</p>
                  </div>
                  <div className="">
                    <button className="btn read_more_btn">
                      {" "}
                      <span>Read More</span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-lg-4  mb-lg-0 mb-3">
                <div className="event_box">
                  <img
                    src={eventThree}
                    alt=""
                    className="img-fluid event_img"
                  />
                  <div className="event_text_content">
                    <div className="date_text">10 April 2020By Admin</div>
                    <p>2020 Insurance Trends And Possible Challenge.</p>
                  </div>
                  <div className="">
                    <button className="btn read_more_btn">
                      {" "}
                      <span>Read More</span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="event_box">
                  <img src={eventOne} alt="" className="img-fluid event_img" />
                  <div className="event_text_content">
                    <div className="date_text">10 April 2020By Admin</div>
                    <p>2020 Insurance Trends And Possible Challenge</p>
                  </div>
                  <div className="">
                    <button className="btn read_more_btn">
                      <span>Read More</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Events;
